<template>
  <div class="row">
    <div class="event-form">
      <h1 class="text-2xl text-center">
        Events -
        {{ `${editEvent ? "Edit" : "Create"} ${event.event_key_type || ""}` }}
      </h1>
      <div class="m-auto">
        <form autocomplete="off" @submit.prevent="handleSubmit">
          <div v-if="event.event_key_type" class="flex flex-col fadeIn">
            <div v-if="event.event_key_type === 'contest'">
              <label for="event-key-id-focus">Select Assessment</label>
              <VueSelect
                id="event-key-id-focus"
                v-model="selectedEvent"
                :options="eventKeyOptions"
                label="name"
                :disabled="editEvent"
                placeholder="Search for assessments"
                @input="populateEvent"
                @search="searchAssessments"
              />
            </div>
            <div v-if="event.event_key_type === 'liveclass'">
              <label class="font-normal"
                >Liveclass Provider :
                <div
                  v-if="editEvent"
                  class="ml-4 mt-2 text-lg font-normal inline-block"
                >
                  <span class="text-white bg-green px-2 rounded-sm mr-4"
                    >{{ event.liveclass_provider }}
                  </span>
                  <span
                    v-if="event.liveclass_provider === 'zoom'"
                    :style="
                      zoom_account_email == 'aneeq@edyst.com' ||
                      zoom_account_email == 'msrinivasa@edyst.com' ||
                      zoom_account_email == 'winerec374@dwgtcm.com'
                        ? 'background: lightblue'
                        : 'background: lighhtgreen'
                    "
                    class="px-2 rounded-sm"
                    >{{ zoom_account_email }}</span
                  >
                </div></label
              >

              <div
                v-if="!editEvent"
                class="flex justify-start items-center mt-2"
              >
                <label
                  v-for="item in liveclass.providers"
                  :key="item"
                  :for="item"
                  class="flex items-center justify-start providers-container bg-grey-light hover:bg-grey mx-2 rounded-sm cursor-pointer"
                >
                  <input
                    :id="item"
                    v-model="event.liveclass_provider"
                    type="radio"
                    :value="item"
                    :disabled="editEvent"
                    name="provider"
                    @change="handleChange(item)"
                  />
                  {{ getCapitalizedName(item) }}
                </label>
              </div>
            </div>
            <div v-if="liveclass.providers.includes(event.liveclass_provider)">
              <label for="event-name"
                >Event Name
                <span class="text-sm"
                  >( {{ event.event_name ? event.event_name.length : 0 }}/50
                  Characters )</span
                ></label
              >
              <input
                id="event-name"
                v-model.trim="event.event_name"
                required="true"
                type="text"
                name="Live class Name"
                placeholder="Event name"
                @input="handleError"
              />
              <div v-if="error_bag.event_name" class="text-red">
                {{ error_bag.event_name }}
              </div>
            </div>
            <div
              v-if="
                event.event_key_type === 'liveclass' && event.liveclass_provider
              "
            >
              <div class="flex justify-between items-center mt-2">
                <div
                  v-if="liveclass.providers.includes(event.liveclass_provider)"
                  class="host-email"
                >
                  <label for="email">Host Email</label>
                  <input
                    id="email"
                    v-model.trim="event.host_email"
                    required="true"
                    type="email"
                    placeholder="Host email"
                    name="host email"
                  />
                </div>
                <div class="">
                  <label for="event-key-id">Start Date</label>
                  <EdystDatePicker
                    v-model="event.start_date"
                    :selected="event.start_date"
                    placeholderText="Select start date"
                    class="date-picker"
                    @input="handleDateInput('start_date')"
                  />
                </div>
                <div class="">
                  <label for="event-key-id">End Date</label>
                  <EdystDatePicker
                    v-model="event.end_date"
                    :minDate="event.start_date"
                    :selected="event.end_date"
                    placeholderText="Select end date"
                    class="date-picker"
                    @input="handleDateInput('end_date')"
                  />
                </div>
                <div>
                  <label
                    v-if="event.event_key_type === 'liveclass'"
                    for="event-key-id"
                    class="relative"
                    >Duration (in seconds)
                  </label>
                  <div>{{ event.duration_secs }} sec</div>
                </div>
              </div>
              <div
                v-if="event.liveclass_provider === 'youtube'"
                class="host-email"
              >
                <label for="email">Youtube Live URL</label>
                <input
                  id="youtube_link"
                  v-model.trim="youtube_link"
                  required="true"
                  name="Youtube Link"
                  placeholder="Enter YouTube live URL"
                  @blur="fetchYoutubeLinkData"
                />
              </div>
              <div
                v-if="event.liveclass_provider === 'livestream'"
                class="mt-2"
              >
                <label for="livestream-id"
                  >Livestream ID<span class="text-red ml-2 text-xs"
                    >(Only one time event id is accepted. ex: 529912358)</span
                  ><button
                    :disabled="!event.event_key_id"
                    style="padding: 0.1rem 1rem"
                    class="rounded-sm bg-purple-dark test-btn ml-2 text-sm"
                    @click.prevent="testEmbed"
                  >
                    Test Embed
                  </button></label
                >
                <input
                  id="livestream-id"
                  v-model.trim="event.event_key_id"
                  type="number"
                  name="livestream id"
                  placeholder="Enter one time event id"
                  minlength="9"
                  maxlength="9"
                />
                <label for="live-chat-code"
                  >Livestream Chat embed code
                  <span class="text-red text-xs"
                    >(Copy the responsive embed code)</span
                  ><button
                    :disabled="!event.livestream_chat_embed_html"
                    style="padding: 0.1rem 1rem"
                    class="rounded-sm bg-purple-dark test-btn ml-2 text-sm"
                    @click.prevent="testLiveChat"
                  >
                    Test Chat
                  </button></label
                >
                <textarea
                  id="livestream-id"
                  v-model.trim="event.livestream_chat_embed_html"
                  name="live-chat-code"
                  placeholder="Enter live chat embed code"
                  class="border w-full p-2"
                >
                </textarea>
              </div>

              <div v-if="getLiveClassProvider" class="">
                <label for="watch_offline">Watch Offline URL</label>
                <input
                  id="watch_offline"
                  v-model.trim="event.watch_offline_url"
                  placeholder="Enter class recording link to allow watch it later"
                  name="Watch Offline URL"
                />
              </div>

              <div class="flex justify-between items-center w-1/2 mt-2">
                <div>
                  <label>Payment Type</label>
                  <div class="flex mt-1">
                    <label
                      for="paid"
                      class="flex items-center"
                      style="display:flex;height:25px;padding:0;font-weight:normal"
                    >
                      <input
                        id="paid"
                        v-model="event.payment_type"
                        type="radio"
                        name="radio"
                        style="width:1.4rem;height:1.4rem"
                        value="paid"
                        class="mr-2"
                      />Paid</label
                    >
                    <label
                      for="free"
                      class="flex items-center ml-12"
                      style="display:flex;height:25px;padding:0;font-weight:normal"
                      ><input
                        id="free"
                        v-model="event.payment_type"
                        type="radio"
                        name="radio"
                        style="width:1.4rem;height:1.4rem"
                        value="free"
                        class="mr-2"
                      />Free</label
                    >
                  </div>
                </div>
                <div
                  v-if="liveclass.providers.includes(event.liveclass_provider)"
                  class="max-registration-count"
                >
                  <label for="max-registration-count"
                    >Maximum Registration Number</label
                  >
                  <input
                    id="max-registration-count"
                    v-model="event.max_registrations"
                    required="true"
                    type="number"
                    name="max student registration"
                  />
                </div>
              </div>
              <details
                v-if="event.liveclass_provider === 'zoom' && editEvent"
                class="bg-grey-lighter rounded mt-5 hover:bg-grey-light meeting-deails"
              >
                <summary class="cursor-pointer p-2"
                  >ZOOM Meeting and Joining Details</summary
                >
                <div class="ml-4 p-2 pt-0">
                  <div class="mt-4">
                    <label
                      class="flex justify-start items-center"
                      style=" display:flex;padding:0;"
                      for="zoom-account-email"
                      >Zoom Account Email ID:
                      <span
                        :style="
                          zoom_account_email == 'aneeq@edyst.com' ||
                          zoom_account_email == 'msrinivasa@edyst.com' ||
                          zoom_account_email == 'winerec374@dwgtcm.com'
                            ? 'background: lightblue'
                            : 'background: lighhtgreen'
                        "
                        class="px-2 rounded-sm ml-4"
                        >{{ zoom_account_email }}</span
                      >
                    </label>
                  </div>
                  <div class="flex items-center mt-2">
                    <label for="start-url" class="flex-no-shrink"
                      >Start URL</label
                    >
                    <input
                      id="start-url"
                      :value="start_url"
                      type="text"
                      class="ml-4"
                      readonly
                    />
                  </div>
                  <div class="flex items-center mt-2">
                    <label for="join-url" class="flex-no-shrink"
                      >Join URL</label
                    >
                    <input
                      id="join-url"
                      :value="join_url"
                      type="text"
                      class="ml-4"
                      readonly
                    />
                  </div>
                  <div class="flex items-center mt-2 w-2/3">
                    <label for="pass-code" class="flex-no-shrink"
                      >Passcode</label
                    >
                    <input
                      id="pass-code"
                      :value="passcode"
                      type="text"
                      class="ml-4"
                      readonly
                    />
                  </div>
                </div>
              </details>
            </div>

            <div
              v-if="
                event.event_key_type === 'contest' ||
                  (event.event_key_type === 'liveclass' &&
                    event.liveclass_provider)
              "
            >
              <div
                v-if="event.event_key_type === 'contest'"
                class="w-full flex date-picker"
              >
                <div class="mr-3 w-1/3">
                  <label for="event-key-id">Event Start Date</label>
                  <EdystDatePicker
                    v-model="event.start_date"
                    :selected="event.start_date"
                    placeholderText="Select start date"
                    @input="handleDateInput"
                  />
                </div>
                <div class="mr-3 w-1/3">
                  <label for="event-key-id">Event End Date</label>
                  <EdystDatePicker
                    v-model="event.end_date"
                    :selected="event.end_date"
                    placeholderText="Select end date"
                    @input="handleDateInput"
                  />
                </div>
                <div class="w-1/3">
                  <label
                    v-if="event.event_key_type === 'liveclass'"
                    for="event-key-id"
                    class="relative"
                    >Duration (in seconds)
                    <span class="text-red absolute">
                      auto populated</span
                    ></label
                  >
                  <label
                    v-if="event.event_key_type === 'contest'"
                    for="event-key-id"
                    title="How long is the assessment"
                    >Duration of the assessment ( seconds)</label
                  >
                  <div class="relative">
                    <input
                      v-model="event.duration_secs"
                      :disabled="
                        event.event_key_type === 'contest' || editEvent
                      "
                      :class="
                        event.duration_secs < 0
                          ? 'bg-red-light text-white'
                          : 'bg-white text-black border-none'
                      "
                    />
                  </div>
                </div>
              </div>
              <div
                v-if="event.event_key_type === 'contest'"
                class="max-registration-count"
              >
                <label for="max-registration-count"
                  >Maximum Registration Number</label
                >
                <input
                  id="max-registration-count"
                  v-model="event.max_registrations"
                  required="true"
                  type="number"
                  name="max student registration"
                />
              </div>
              <div
                v-if="event.event_key_type === 'contest'"
                class="mr-3 w-full"
              >
                <label for="event-key-id"
                  >Registration Deadline (seconds left to contest)</label
                >
                <input
                  v-model="event.registration_deadline"
                  type="number"
                  placeholder="Add seconds left to contest"
                />
              </div>
              <div v-if="event.event_key_type === 'contest'" class="flex mt-2">
                <label for="public_event">Available to public</label>
                <div>
                  <input
                    id="public_event"
                    v-model="event.is_public"
                    class="mr-12 mt-3"
                    type="checkbox"
                    name="is_public"
                  />
                </div>
              </div>
              <div class="flex mt-2">
                <label for="unlisted_event">Unlisted</label>
                <div>
                  <input
                    id="unlisted_event"
                    v-model="event.unlisted"
                    class="mr-12 mt-3"
                    type="checkbox"
                    name="unlisted"
                  />
                </div>
              </div>
              <div class="flex mt-2">
                <label for="visible_to_public">Visible to public</label>
                <div class="ml-1 mr-4">
                  <span class="ed-tooltip-container">
                    <span class="ed-tooltip-icon">i</span>
                    <span class="ed-tooltip-text text-sm font-normal">
                      Checking this box will make the event visible to all
                      users.
                    </span>
                  </span>
                </div>
                <div>
                  <input
                    id="visible_to_public"
                    v-model="event.visible_to_public"
                    class="mr-12 mt-3"
                    type="checkbox"
                    name="visible_to_public"
                  />
                </div>
              </div>
              <div v-if="event.event_key_type === 'contest'">
                <label>Payment Type</label>
                <div class="flex mt-1">
                  <label
                    for="paid"
                    class="flex items-center"
                    style="display:flex;height:25px;padding:0;font-weight:normal"
                  >
                    <input
                      id="paid"
                      v-model="event.payment_type"
                      type="radio"
                      name="radio"
                      style="width:1.4rem;height:1.4rem"
                      value="paid"
                      class="mr-2"
                    />Paid</label
                  >
                  <label
                    for="free"
                    class="flex items-center ml-12"
                    style="display:flex;height:25px;padding:0;font-weight:normal"
                    ><input
                      id="free"
                      v-model="event.payment_type"
                      type="radio"
                      name="radio"
                      style="width:1.4rem;height:1.4rem"
                      value="free"
                      class="mr-2"
                    />Free</label
                  >
                </div>
              </div>
              <div v-if="event.event_key_type === 'contest'" class="mb-8">
                <label>Other Fields</label>
                <CustomField
                  v-for="(inputkey, index) in customFieldKeys"
                  :key="index"
                  :inputIndex="index"
                  :inputKey="inputkey"
                  :inputValue="customFieldValues[index]"
                  @FIELD_REMOVED="removeCustomField"
                />
                <CustomField
                  :inputIndex="customFieldKeys.length"
                  @FIELD_ADDED="addCustomField"
                />
              </div>
              <div
                v-if="event.event_key_type === 'contest'"
                class="w-full mr-10 mb-12"
                style="height:300px;"
              >
                <label for="data">Description</label>
                <QuillEditor
                  ref="myQuillEditor"
                  v-model="event.description"
                  style="height: 200px;"
                  :options="quillEditorOptions"
                />
              </div>

              <div class="flex mt-4">
                <div class="w-1/2">
                  <div>
                    <label
                      >Invite Cohort ({{
                        `${usersCountOfInvitedCohorts} Students`
                      }})
                    </label>
                    <VueSelect
                      v-model="inviteCohorts"
                      :closeOnSelect="false"
                      placeholder="Select a Cohort"
                      :options="cohortList"
                      :reduce="cohort => cohort.name"
                      :multiple="true"
                      label="name"
                    />
                  </div>
                </div>
                <div class="w-1/2 ml-3 relative">
                  <div>
                    <label for="user-id"
                      >Invite Users ({{
                        invitedStudentsByEmail > 1 ||
                        invitedStudentsByEmail == 0
                          ? `${invitedStudentsByEmail} Students`
                          : `${invitedStudentsByEmail} Student`
                      }})
                    </label>
                    <textarea
                      id="user-id"
                      v-model.trim="event.explicitly_invited_users_list"
                      rows="2"
                      cols="30"
                      class="p-3 border w-full"
                      placeholder="Enter one or more user id or email (separated by comma or newline)"
                    />
                  </div>
                </div>
              </div>

              <div class="flex">
                <div class="w-1/2">
                  <div class="w-full">
                    <label
                      >Register Cohort ({{
                        `${usersCountOfRegisteredCohorts} Students`
                      }})
                    </label>
                    <VueSelect
                      v-model="registerCohorts"
                      placeholder="Select a Cohort"
                      :closeOnSelect="false"
                      :options="cohortList"
                      :reduce="cohort => cohort.name"
                      :multiple="true"
                      label="name"
                    />
                  </div>
                </div>
                <div class="w-1/2 ml-4">
                  <label for="user-id"
                    >Register Users ({{
                      registeredStudentsByEmail > 1 ||
                      registeredStudentsByEmail == 0
                        ? `${registeredStudentsByEmail} Students`
                        : `${registeredStudentsByEmail} Student`
                    }})</label
                  >
                  <textarea
                    id="user-id"
                    v-model.trim="event.explicitly_registered_users_list"
                    rows="2"
                    cols="30"
                    class="p-3 border w-full"
                    placeholder="Enter one or more user id or email (separated by comma or newline)"
                  />
                </div>
              </div>
              <div class="mb-4">
                <label>Thumbnail URL</label>
                <div class="w-full mt-3">
                  <ThumbnailGenerator
                    v-model="event.thumbnail_url"
                    :text="event.event_name"
                    :context_type="event.event_key_type"
                    name="thumbnail"
                    style="width:20rem"
                  />
                  <small class="err-msg text-red block mt-2">
                    {{ veeValidateErrors.first("thumbnail") }}
                  </small>
                  <input
                    v-model="event.thumbnail_url"
                    v-validate="'required'"
                    type="hidden"
                    name="thumbnail"
                  />
                </div>
              </div>
              <div class="flex">
                <div class="w-1/2">
                  <div class="w-full">
                    <label>Register QuestionBank Cohort </label>
                    <VueSelect
                      v-model="registeredQuestionBankCohorts"
                      placeholder="Select a Cohort"
                      :closeOnSelect="false"
                      :options="questionBankCohortsList"
                      :reduce="cohort => cohort.name"
                      :multiple="true"
                      label="name"
                    />
                  </div>
                  <div class="mt-8">
                    <label>Register QuestionBank Groups</label>
                    <div
                      v-for="(item, i) in registeredQuestionBankCohorts"
                      :key="i"
                      class="my-3"
                    >
                      <div class="mt-3">
                        {{ item.name }} <span class="text-red ml-2">*</span>
                      </div>
                      <VueSelect
                        v-model="item.cohort_groups"
                        v-validate="'required'"
                        multiple
                        :searchable="true"
                        :closeOnSelect="false"
                        :options="getCohortGroups(item.id)"
                        label="name"
                        name="Groups"
                      />
                    </div>
                    <small class="err-msg text-red block mt-2">
                      {{ veeValidateErrors.first("Groups") }}
                    </small>
                  </div>
                </div>
                <div class="w-1/2 ml-4 mt- 5">
                  <div class="w-full">
                    <label>Invited QuestionBank Cohort </label>
                    <VueSelect
                      v-model="invitedQuestionBankCohorts"
                      placeholder="Select a Cohort"
                      :closeOnSelect="false"
                      :options="questionBankCohortsList"
                      :reduce="cohort => cohort.name"
                      :multiple="true"
                      label="name"
                    />
                  </div>
                  <div class="mt-8">
                    <div
                      v-for="(item, i) in invitedQuestionBankCohorts"
                      :key="i"
                      class="my-3"
                    >
                      <label>Invited QuestionBank Groups</label>
                      <div class="mt-3">{{ item.name }}</div>
                      <VueSelect
                        v-model="item.cohort_groups"
                        v-validate="'required'"
                        multiple
                        :searchable="true"
                        :closeOnSelect="false"
                        :options="getCohortGroups(item.id)"
                        label="name"
                        name="Groups"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <details
                v-if="editEvent"
                class="bg-grey-lighter rounded hover:bg-grey-light mt-4"
              >
                <summary class="cursor-pointer p-2"
                  >Final List of registered cohorts and users</summary
                >
                <div class="flex p-2 pt-0 ml-4">
                  <div class="w-full mr-3">
                    <label for="user-id">Total invited user ids </label>
                    <textarea
                      id="user-id"
                      v-model.trim="event.invite_users_list"
                      readonly
                      rows="10"
                      cols="30"
                      class="p-3 border w-full"
                      style="box-sizing:border-box;"
                      placeholder="No users invited"
                    />
                  </div>
                  <div class="w-full">
                    <label for="user-id">Total registered user ids </label>
                    <textarea
                      id="user-id"
                      v-model.trim="event.registered_users_list"
                      readonly
                      rows="10"
                      cols="30"
                      class="p-3 border w-full"
                      style="box-sizing:border-box;"
                      placeholder="No users registered"
                    />
                  </div>
                </div>
              </details>
              <button
                type="submit"
                class="button-blue my-5 submit-btn px-4 py-2"
                :disabled="
                  liveclassUpdateInProgress || liveclassCreationInProgress
                "
              >
                {{ editEvent ? "Update Event" : "Create Event" }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <VModal name="live-chat-modal" width="400" height="600">
      <div
        class="w-full h-full"
        v-html="event.livestream_chat_embed_html"
      ></div>
    </VModal>

    <VModal name="embed-modal" width="1280" height="720">
      <iframe
        class="w-full h-full"
        :src="getVimeoEmbedURLById"
        frameborder="0"
        allow="autoplay; fullscreen"
      ></iframe>
    </VModal>
  </div>
</template>

<script>
import VueSelect from "vue-select"
import { quillEditor } from "vue-quill-editor"
import { getIdFromURL } from "vue-youtube-embed"
import { differenceInSeconds, addHours, differenceInMinutes } from "date-fns"
import siteConfig from "@/utils/siteConfig"
import CustomField from "./CustomField"
import EdystDatePicker from "@/components/ReactDatePicker/DatePicker"
import ThumbnailGenerator from "@/components/shared/ThumbnailGenerator"

import {
  addEvent,
  putEvent,
  getContests,
  getEventBySlug,
  getCohorts,
  fetchAssignmentById,
} from "@/apis/events/"

import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
import "quill/dist/quill.bubble.css"

export default {
  components: {
    VueSelect,
    QuillEditor: quillEditor,
    CustomField,
    EdystDatePicker,
    ThumbnailGenerator,
  },
  data() {
    return {
      event: {
        event_name: undefined,
        description: "",
        event_key_id: "",
        livestream_chat_embed_html: "",
        event_key_type: this.$route.params.eventType,
        liveclass_provider: "zoom",
        start_date: null,
        end_date: null,
        invite_users_list: "",
        registered_users_list: "",
        invite_cohorts_list: [],
        registered_cohorts_list: [],
        explicitly_invited_users_list: "",
        explicitly_registered_users_list: "",
        data: {},
        duration_secs: null,
        host_email: "",
        max_registrations:
          this.$route.params.eventType === "contest" ? 10000 : 0,
        registration_deadline: 0,
        watch_offline_url: "",
        payment_type:
          this.$route.params.eventType === "liveclass" ? "paid" : "free",
        is_public: false,
        unlisted: false,
        thumbnail_url: "",
        visible_to_public: false,
      },
      serverUrl: `${siteConfig.siteURL}uploads/public`,
      zoom_account_email: "",
      start_url: "",
      join_url: "",
      passcode: "",
      approvalTypes: [0, 1, 2],
      audioOptions: ["both", "telephony", "voip"],
      autoRecordOptions: ["local", "cloud", "none"],
      customFieldKeys: [],
      customFieldValues: [],
      eventKeyOptions: [],
      cohortList: [],
      selectedEvent: undefined,
      quillEditorOptions: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ list: "bullet" }],
          ],
        },
        placeholder: "Enter event description here...",
        readOnly: true,
        theme: "snow",
      },
      inviteCohorts: [],
      registerCohorts: [],
      liveclass: {
        providers: ["zoom", "youtube", "livestream"],
      },
      youtube_link: undefined,
      error_bag: {
        event_name: "",
      },
      liveclassUpdateInProgress: false,
      liveclassCreationInProgress: false,
      registeredQuestionBankCohorts: [],
      invitedQuestionBankCohorts: [],
      questionBankCohortsList: [],
    }
  },
  computed: {
    usersCountOfInvitedCohorts() {
      if (this.inviteCohorts) {
        return this.inviteCohorts.reduce(
          (currentCount, cohort) => currentCount + cohort.user_count,
          0
        )
      }
      return 0
    },
    usersCountOfRegisteredCohorts() {
      if (this.registerCohorts) {
        return this.registerCohorts.reduce(
          (currentCount, cohort) => currentCount + cohort.user_count,
          0
        )
      }
      return 0
    },
    getVimeoEmbedURLById() {
      if (this.event.event_key_id && this.event.event_key_id.length === 9) {
        return `https://player.vimeo.com/video/${this.event.event_key_id}`
      }
      return ``
    },
    editEvent() {
      return !!this.$route.params.slug
    },
    registeredStudentsByCohort() {
      if (this.event && this.event.registered_cohorts_list.length > 0) {
        let count = 0
        this.cohortList.forEach(c => {
          this.event.registered_cohorts_list.forEach(item => {
            if (c.id === item) {
              count += c.user_count
            }
          })
        })
        return count
      }
      return 0
    },
    invitedStudentsByEmail() {
      if (this.event && this.event.explicitly_invited_users_list.length > 0) {
        return this.getEmailCount("invited")
      }
      return 0
    },
    registeredStudentsByEmail() {
      if (
        this.event &&
        this.event.explicitly_registered_users_list.length > 0
      ) {
        return this.getEmailCount("registered")
      }
      return 0
    },
    totalRegisteredStudents() {
      if (
        this.event &&
        this.event.explicitly_registered_users_list.length > 0
      ) {
        return this.getEmailCount("")
      }
      return 0
    },
    getLiveClassProvider() {
      return (
        this.event.liveclass_provider === "zoom" ||
        (this.editEvent === true &&
          this.event.liveclass_provider === "youtube") ||
        this.event.liveclass_provider !== "livestream"
      )
    },
  },
  created() {
    this.fetchEvents()
    this.fetchQuestionBankCohorts()
  },
  methods: {
    searchAssessments(search, loading) {
      loading(true)
      getContests(search)
        .then(res => {
          this.eventKeyOptions = res.data.items
          loading(false)
        })
        .catch(err => {
          console.error(err)
          this.$noty.error("Failed to fetch assessments")
          loading(false)
        })
    },
    testEmbed() {
      if (this.event.event_key_id && this.event.event_key_id.length === 9) {
        this.$modal.show("embed-modal")
      } else {
        this.$noty.error("Invalid embed id")
      }
    },
    testLiveChat() {
      this.$modal.show("live-chat-modal")
    },
    handleDateInput(type) {
      // only populate when start date is null while creating a class
      if (type === "start_date" && !this.editEvent && !this.event.end_date) {
        this.event.end_date = addHours(new Date(this.event.start_date), 2)
      }
      if (
        this.event.start_date &&
        this.event.end_date &&
        this.event.event_key_type === "liveclass"
      ) {
        this.event.duration_secs = differenceInSeconds(
          new Date(this.event.end_date),
          new Date(this.event.start_date)
        )
      }
    },
    handleError() {
      this.error_bag.event_name = ""
      if (this.event.event_name && this.event.event_name.length > 50) {
        if (!this.error_bag.event_name) {
          this.error_bag.event_name = "Max length 50"
        }
      }
    },
    validateYouTubeURL(url) {
      // const p = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/
      const p = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=))((\w|-){11})(?:\S+)?$/
      const matches = url.match(p)
      if (matches) {
        return true
      }
      this.$noty.error(
        "Please use the youtube url in this format - http://www.youtube.com/watch?v=-wtIMTCHWvI",
        {
          layout: "topRight",
          theme: "relax",
        }
      )
      return false
    },
    fetchYoutubeLinkData() {
      // fetch youtube data and set state
      // duration + start time + end time
      //
      if (!this.youtube_link) return
      if (!this.validateYouTubeURL(this.youtube_link)) return
      const video_id = getIdFromURL(this.youtube_link)
      const api_key = "AIzaSyAGcphfyXaav-WYeLnWcuVLVdEVqa3HLQk"
      const api_url = `https://www.googleapis.com/youtube/v3/videos?part=snippet%2Cstatistics%2CliveStreamingDetails&id=${video_id}&key=${api_key}`
      this.axios
        .get(api_url)
        .then(res => {
          const startTime =
            res.data.items[0] &&
            res.data.items[0].liveStreamingDetails &&
            res.data.items[0].liveStreamingDetails.scheduledStartTime
          const event_name = res.data.items[0].snippet.title

          if (startTime) {
            const start_time = new Date(startTime)
            let end_time = new Date(startTime)
            end_time = end_time.getTime() + 3600 * 1000
            end_time = new Date(end_time)
            const duration = (end_time - start_time) / 1000
            // start - end times
            this.event.start_date = new Date(start_time)
            this.event.end_date = new Date(end_time)
            // set duration
            this.event.duration_secs = duration
          }

          this.event.max_registrations = 5000
          this.event.event_key_id = video_id
          this.event.event_name = event_name
        })
        .catch(err => {
          console.error(err)
        })
    },
    getEmailCount(type) {
      const splitEmailString = emails => {
        const formatCSV = emails.split(",").filter(f => f)
        if (formatCSV.length > 1) {
          return formatCSV.length
        }
        const formatNewLine = emails.split("\n").filter(f => f)
        if (formatNewLine.length) {
          return formatNewLine.length
        }
        return 0
      }
      if (type === "invited") {
        return splitEmailString(this.event.explicitly_invited_users_list)
      }
      if (type === "registered") {
        return splitEmailString(this.event.explicitly_registered_users_list)
      }
      return 0
    },
    handleMeetingNoChange() {
      let loader
      if (this.event.event_key_id && this.event.event_key_id.length >= 9) {
        loader = this.$loading.show()
        // remove all spaces and dashes(-) from api key
        const trimmedNo = this.event.event_key_id.replace(/-| /g, "")

        this.axios({
          method: "GET",
          url: `${siteConfig.siteURL}events/zoom/admin/${trimmedNo}`,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-access-token": localStorage.token,
          },
        })
          .then(res => {
            loader.hide()
            if (res.data.status) {
              this.event.start_date = new Date(res.data.meeting.start_time)
              this.event.end_date = new Date(res.data.meeting.end_time)
              this.event.duration_secs = res.data.meeting.duration * 60 // get seconds
              this.event.event_name = res.data.meeting.topic
            } else {
              this.$noty.error(res.data.message)
            }
          })
          .catch(err => {
            loader.hide()
            console.error(err)
          })
      }
    },
    handleChange(type) {
      // change event type isn't allowed during edit
      // so we don't need to reset fields
      if (!this.editEvent) {
        if (type === "youtube") {
          this.event.host_email = ""
          this.event.max_registrations = 0
          this.event.event_name = ""
          this.event.event_key_id = ""
        } else if (type === "zoom") {
          this.youtube_link = ""
          this.event.duration_secs = 0
          this.event.max_registrations = 0
          this.event.event_key_id = ""
          this.event.event_name = ""
          this.event.start_date = new Date()
          this.event.end_date = new Date()
        }
      }
    },
    handleFocus() {
      if (!this.$route.params.slug) {
        const el = this.$el.querySelector("#event-key-id-focus")
        if (el) {
          el.querySelector("input[type=search]").focus()
        }
      }
    },
    handleSubmit() {
      if (this.editEvent) {
        this.updateEvent()
      } else {
        this.createEvent()
      }
    },
    validate() {
      if (
        differenceInMinutes(this.event.end_date, this.event.start_date) <= 0
      ) {
        this.$noty.error("End Date must be greater than Start Date")
        return false
      }
      if (this.event.event_key_type === "contest" && !this.selectedEvent) {
        this.$noty.error("Event Key is not selected!")
        return false
      }
      if (this.event.event_key_type === "contest") {
        try {
          this.event.duration_secs = parseInt(this.event.duration_secs) || null
          if (!this.event.duration_secs) throw new Error("Invalid duration")
        } catch (e) {
          this.$noty.error(
            "Event Duration (secs) should be a positive integer!"
          )
          return false
        }
      }
      if (
        this.event.event_key_type === "liveclass" &&
        this.event.liveclass_provider === "youtube"
      ) {
        if (!this.validateYouTubeURL(this.youtube_link)) {
          return false
        }
        if (this.event.watch_offline_url) {
          if (!this.validateYouTubeURL(this.event.watch_offline_url)) {
            return false
          }
        }
      }

      if (
        this.event.event_key_type === "liveclass" &&
        !(
          this.event.start_date &&
          this.event.end_date &&
          this.event.duration_secs > 0
        )
      ) {
        this.$noty.error(
          "Liveclass Duration (secs) should be a positive integer!",
          {
            layout: "topRight",
            theme: "relax",
          }
        )
        return false
      }

      let error_list = Object.keys(this.error_bag).map(
        field => this.error_bag[`${field}`].length
      )
      error_list = error_list.filter(e => e)
      if (error_list.length) {
        return false
      }
      return true
    },
    createEvent() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$noty.error("Please fill all the required fields marked with *")
          return
        }
        if (!this.validate()) {
          return
        }
        const data = {}
        this.customFieldKeys.forEach((key, index) => {
          data[key] = this.customFieldValues[index]
        })
        this.event.data = data
        const eventObj = {
          ...this.event,
          start_date: new Date(this.event.start_date).toISOString(),
          end_date: new Date(this.event.end_date).toISOString(),
          invite_cohorts_list: this.inviteCohorts.map(c => c.id),
          registered_cohorts_list: this.registerCohorts.map(c => c.id),
          meeting_details: {},
          registered_question_bank_cohorts:
            this.registeredQuestionBankCohorts.length > 0
              ? this.registeredQuestionBankCohorts.map(item => ({
                  id: item.id,
                  name: item.name,
                  cohort_groups: item.cohort_groups,
                }))
              : [],
          invited_question_bank_cohorts:
            this.invitedQuestionBankCohorts.length > 0
              ? this.invitedQuestionBankCohorts.map(item => ({
                  id: item.id,
                  name: item.name,
                  cohort_groups: item.cohort_groups,
                }))
              : [],
        }
        eventObj.watch_offline_url = this.youtube_link
        eventObj.max_registrations = parseInt(this.event.max_registrations)
        if (
          this.event.event_key_type === "liveclass" &&
          this.event.liveclass_provider === "zoom"
        ) {
          eventObj.meeting_details.start_url = this.start_url
          eventObj.meeting_details.join_url = this.join_url
          eventObj.meeting_details.passcode = this.passcode
        }
        const loader = this.$loading.show()
        this.liveclassCreationInProgress = true
        addEvent(eventObj)
          .then(res => {
            if (res.data.status) {
              this.$noty.success("Created Event successfully")
              // we're storing event type as route param,
              // so sending to the same event list page
              this.$router.push(`/event-list/${this.event.event_key_type}`)
            } else {
              this.$noty.error(
                `Something went wrong. ${
                  res.data.message
                    ? `Server responded with : ${res.data.message}`
                    : ""
                }`
              )
            }
          })
          .catch(err => {
            let response = err.response.data
            if (response && response.message) {
              response = response.message
            }
            this.$noty.error(
              `Something went wrong, server responded with : ${response}`
            )
          })
          .finally(() => {
            this.liveclassCreationInProgress = false
            loader.hide()
          })
      })
    },
    updateEvent() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$noty.error("Please fill all the required fields marked with *")
          return
        }

        if (!this.validate()) {
          return
        }
        const data = {}
        this.customFieldKeys.forEach((key, index) => {
          data[key] = this.customFieldValues[index]
        })
        this.event.data = data
        console.log(this.registeredQuestionBankCohorts, "OOOOOOOOOOOOOOOOOO")

        const eventObj = {
          ...this.event,
          start_date: new Date(this.event.start_date).toISOString(),
          end_date: new Date(this.event.end_date).toISOString(),
          invite_cohorts_list: this.inviteCohorts.map(c => c.id),
          registered_cohorts_list: this.registerCohorts.map(c => c.id),
          meeting_details: {},
          registered_question_bank_cohorts:
            this.registeredQuestionBankCohorts.length > 0
              ? this.registeredQuestionBankCohorts.map(item => ({
                  id: item.id,
                  name: item.name,
                  cohort_groups: item.cohort_groups,
                }))
              : [],
          invited_question_bank_cohorts:
            this.invitedQuestionBankCohorts.length > 0
              ? this.invitedQuestionBankCohorts.map(item => ({
                  id: item.id,
                  name: item.name,
                  cohort_groups: item.cohort_groups,
                }))
              : [],
        }
        eventObj.max_registrations = parseInt(this.event.max_registrations)
        if (
          this.event.event_key_type === "liveclass" &&
          this.event.liveclass_provider === "zoom"
        ) {
          eventObj.meeting_details.start_url = this.start_url
          eventObj.meeting_details.join_url = this.join_url
          eventObj.meeting_details.passcode = this.passcode
        }
        const loader = this.$loading.show()
        this.liveclassUpdateInProgress = true
        putEvent(this.$route.params.slug, eventObj)
          .then(res => {
            if (res.data.status) {
              this.$noty.success("Updated Event successfully")
              this.$router.push(`/event-list/${this.event.event_key_type}`)
            } else {
              this.$noty.error(
                `Something went wrong. ${
                  res.data.message
                    ? `Server responded with : ${res.data.message}`
                    : ""
                }`
              )
            }
          })
          .catch(err => {
            let response = err.response && err.response.data
            if (response && response.message) {
              response = response.message
            }
            this.$noty.error(
              `Something went worng, server responded with :${response ||
                "Internal Server Error (500)"}`
            )
          })
          .finally(() => {
            this.liveclassUpdateInProgress = false
            loader.hide()
          })
      })
    },
    fetchEvents() {
      if (this.$route.params.slug) {
        this.fetchSingleEvent()
      } else {
        this.fetchCohorts()
      }
    },
    async fetchSingleEvent() {
      getEventBySlug(this.$route.params.slug).then(async res => {
        const data = res.data.event
        this.event.slug = data.slug
        this.event.event_name = data.event_name
        window.pageTitle = `Edit - ${data.event_name}`
        this.event.data = data.data ? data.data : {}
        /* eslint-disable no-restricted-syntax */
        for (const key of Object.keys(this.event.data)) {
          this.customFieldKeys.push(key)
          this.customFieldValues.push(this.event.data[key])
        }
        this.event.description = data.description
        this.event.duration_secs = data.duration_secs
        this.event.event_key_id = data.event_key_id
        this.event.event_key_type = data.event_key_type
        this.event.liveclass_provider = data.liveclass_provider || undefined
        this.event.watch_offline_url = data.watch_offline_url
        this.event.thumbnail_url = data.thumbnail_url || ""
        this.event.livestream_chat_embed_html = data.livestream_chat_embed_html
        this.youtube_link =
          data.liveclass_provider === "youtube"
            ? `https://www.youtube.com/watch?v=${data.event_key_id}`
            : undefined
        this.event.start_date = new Date(data.start_date)
        this.event.end_date = new Date(data.end_date)
        this.event.registration_deadline = data.registration_deadline
        if (data.liveclass_provider === "zoom") {
          let { settings } = data.meeting_details
          if (!settings) {
            settings = {
              host_video: true,
              participant_video: false,
              cn_meeting: false,
              in_meeting: true,
              mute_upon_entry: true,
              watermark: false,
              use_pmi: false,
              approval_type: 2,
              audio: "both",
              auto_recording: "local",
              waiting_room: true,
              join_before_host: false,
              start_url: "",
              join_url: "",
              passcode: "",
            }
          }
          this.zoom_account_email = data.zoom_account_email
          this.host_video = settings.host_video
          this.participant_video = settings.participant_video
          this.cn_meeting = settings.cn_meeting
          this.in_meeting = settings.in_meeting
          this.mute_upon_entry = settings.mute_upon_entry
          this.watermark = settings.watermark
          this.use_pmi = settings.use_pmi
          this.approval_type = settings.approval_type
          this.audio = settings.audio
          this.auto_recording = settings.auto_recording
          this.waiting_room = settings.waiting_room
          this.join_before_host = settings.join_before_host
          this.start_url = data.meeting_details.start_url || ""
          this.join_url = data.meeting_details.join_url || ""
          this.passcode = data.meeting_details.passcode || ""
        }
        this.event.payment_type = data.payment_type
        this.event.invite_users_list = data.invite_users_list || ""
        this.event.invite_cohorts_list = data.invite_cohorts_list || []
        this.event.registered_users_list = data.registered_users_list || ""
        this.event.registered_cohorts_list = data.registered_cohorts_list || []
        this.event.explicitly_invited_users_list =
          data.explicitly_invited_users_list || ""
        this.event.explicitly_registered_users_list =
          data.explicitly_registered_users_list || ""
        this.event.is_public = data.is_public
        this.event.unlisted = data.unlisted
        this.event.visible_to_public = data.visible_to_public
        this.registeredQuestionBankCohorts =
          data.registered_question_bank_cohorts || []
        this.invitedQuestionBankCohorts =
          data.invited_question_bank_cohorts || []

        await this.fetchCohorts()
        // populate selected cohort for invite/register
        const registeredCohorts = []
        const invitedCohorts = []
        this.event.registered_cohorts_list.forEach(id => {
          this.cohortList.forEach(cohort => {
            if (id === cohort.id) {
              registeredCohorts.push(cohort)
            }
          })
        })
        this.event.invite_cohorts_list.forEach(id => {
          this.cohortList.forEach(cohort => {
            if (id === cohort.id) {
              invitedCohorts.push(cohort)
            }
          })
        })
        this.registerCohorts = [...registeredCohorts]
        this.inviteCohorts = [...invitedCohorts]

        if (this.event.event_key_type === "contest") {
          const eventRes = await fetchAssignmentById(data.event_key_id)
          this.selectedEvent = {
            name: eventRes.data.path.name,
            id: data.event_key_id,
            path: eventRes.data.path,
            slug: eventRes.data.slug,
          }
          this.populateEvent(this.selectedEvent)
        }

        if (data.max_registrations) {
          this.event.max_registrations = data.max_registrations
        }
        if (data.host) {
          this.event.host_email = data.host.email
        }
        window.pageTitle = `Edit - ${this.event.event_name}`
      })
    },
    populateEvent(event) {
      this.event.slug = event.slug
      this.event.event_key_id = event.id

      this.event.event_name = this.event.event_name || event.name
      window.pageTitle = `Event - ${this.event.event_name}`

      this.event.start_date = this.event.start_date || new Date()
      this.event.end_date = this.event.end_date || new Date()

      if (event.path) {
        const { sections } = event.path
        let total_duration_secs = 0
        sections.forEach(s => {
          total_duration_secs += s.time_limit_secs
        })
        this.event.duration_secs = total_duration_secs
      }
    },
    async fetchCohorts() {
      try {
        const res = await getCohorts()
        this.cohortList = res.data.items.map(c => ({
          ...c,
          /* show user_count with name in dropdown */
          name: `${c.name}: (${c.user_count || 0})`,
        }))
      } catch (err) {
        console.error(err)
        this.$noty.error("Failed to fetch cohorts")
      }
    },
    fetchQuestionBankCohorts() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}question_bank/cohorts?pagination=false`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.questionBankCohortsList = res.data.items.map(item => ({
          id: item.id,
          name: item.name,
          groups: item.groups,
        }))
      })
    },
    addCustomField(key, value) {
      this.customFieldKeys.push(key)
      this.customFieldValues.push(value)
    },
    removeCustomField(index) {
      this.customFieldKeys.splice(index, 1)
      this.customFieldValues.splice(index, 1)
    },
    getCapitalizedName(str = "") {
      return `${str.charAt(0).toUpperCase()}${str.slice(1)}`
    },
    getCohortGroups(cohort_id) {
      if (this.questionBankCohortsList) {
        for (let i = 0; i < this.questionBankCohortsList.length; i++) {
          if (this.questionBankCohortsList[i].id === cohort_id) {
            return this.questionBankCohortsList[i].groups
          }
        }
      }
      return []
    },
  },
}
</script>

<style scoped>
input {
  width: 100%;
}

label {
  display: block;
  padding: 0.7rem 0 0.2rem 0;
  font-size: 16px;
  text-align: left;
}

.providers-container input[type="radio"] {
  width: 1.5rem;
  margin: 0 1rem 0 0;
}

.providers-container {
  display: flex;
  padding: 0.2rem 1rem;
}

.event-form {
  max-width: 65rem;
  margin: auto;
}

.event-form label,
.event-form input[type="text"],
.event-form input[type="email"],
.event-form input[type="number"],
.event-form textarea,
.event-form details,
.event-form input::placeholder {
  color: #414141;
}
.event-form input[type="checkbox"] {
  outline: none;
}
.event-form label,
.event-form summary {
  color: #696969;
  font-weight: bold;
}

.date-picker >>> input {
  width: 100%;
  height: 34px;
  padding-left: 8px;
  border-radius: 4px;
  color: #414141;
}
textarea {
  border-radius: 4px;
}

.meeting-deails input {
  height: 1.5rem;
}

.submit-btn,
.test-btn {
  color: #fff;
}

.ed-tooltip-container {
  display: inline-block;
  position: relative;
  cursor: pointer;
}

.ed-tooltip-icon {
  display: inline-block;
  position: absolute;
  top: -10px;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  color: #fbfbfb;
  background-color: #a3a3a3;
  font-family: "Roboto Mono", monospace;
  font-size: 0.7em;
  line-height: 16px;
  text-align: center;
}

.ed-tooltip-container:hover .ed-tooltip-text {
  display: inline-block;
}

.ed-tooltip-text {
  display: none;
  position: absolute;
  z-index: 100;
  top: 10px;
  left: -90px;
  min-width: 180px;
  max-width: 400px;
  padding: 10px 15px;
  color: #989292;
  background-color: white;
  box-shadow: 1px 2px 10px rgba(0, 0, 0, 0.6);
  font-size: 0.8em;
}

.ed-tooltip-container .ed-tooltip-text::after {
  position: absolute;
  top: -10px;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #fff transparent;
  content: " ";
  transform: translate(7px);
}
</style>
